import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button';

import AgGrid from '../../../Components/Tables/AgGrid/AgGrid';
import Card from '../../../Components/Card/Card'
import { getLabel } from '../../../Services/Language/LanguageService';
import { baseLang } from '../../../Lang/BaseLang';
import { ConfigContext } from '../../../Context/ConfigContext/ConfigContext';

import { EliminarListaCorreos, getListaCorreos } from '../../../API/IT/ListaCorreos/ListaCorreosRequest';
import CRUDListaCorreos from './CRUDListaCorreos'
import { toastShow } from '../../../Services/ToastService';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


const ListaCorreosScreen = () => {
  const [show, setShow] = useState(false);
  const [listaCorreos, setListaCorreos] = useState([]);
  const [loading, setLoading] = useState(false);
  const { config } = useContext(ConfigContext);
  const toast = useRef(null);
  const [selected, setSelected] = useState(null);

  const getInfo = async () => {
    setLoading(true);
    const t = await getListaCorreos();
    setListaCorreos(t);
    setLoading(false);
    setSelected([null]);
  };

  const eliminarListaCorreo = async () => {
    setLoading(true);
    const detalles = selected.map((detalle) => ({
      ...detalle[0],
      IdListaCorreo: detalle?.IdListaCorreo,
    }));

    const respuesta = await EliminarListaCorreos(detalles);

    if ((respuesta[0].ESTADO = 1)) {
      toastShow(toast, "success", "Eliminada", respuesta[0].MENSAJE);
      getInfo();
    } else {
      toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
    }
    setLoading(false);
  };

  const cerrarConfirmacion = () => {
    confirmDialog({
      message: "¿Estás seguro que deseas eliminar la lista?",
      header: "Eliminar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      accept: () => {
        eliminarListaCorreo();
      },
      rejectLabel: "No",
      reject: () => {}, // No hacer nada si el usuario cancela
      style: { backgroundColor: "white" },
    });
  };

  const columns = [
    {
      header: "ID",
      field: "IdListaCorreo",
      className: "XXsmall",
    },
    {
      header: "Asunto",
      headerEn: "Title",
      field: "Asunto",
      className: "XXXXlarge",
    },
    {
      header: "DestinatariosMail",
      className: "XXlarge",
      field: "DestinatariosMail",
    },
    {
      header: "CCMail",
      className: "XXlarge",
      field: "CCMail",
    },
    {
      header: "CCo Externos",
      className: "XXlarge",
      field: "CCoMail",
    },
    {
      header: "CC Externos",
      className: "XXlarge",
      field: "CCMail",
    },
    {
      header: "Destinatarios Externos",
      className: "XXlarge",
      field: "Destinatarios",
    },
    {
      field: "IdListaCorreo",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            const a = {
              IdListaCorreo: rowData.IdListaCorreo,
              Asunto: rowData.Asunto,
              Destinatarios: rowData.Destinatarios
                ? rowData.Destinatarios.split(",")
                : [],
              IdUsersDestinatarios: rowData.IdUsersDestinatarios
                ? rowData.IdUsersDestinatarios.split(",").map((e) =>
                    parseInt(e)
                  )
                : [],
              IdRolDestinatarios: rowData.IdRolDestinatarios
                ? rowData.IdRolDestinatarios.split(",").map((e) => parseInt(e))
                : [],
              CC: rowData.CC ? rowData.CC.split(",") : [],
              IdUserCC: rowData.IdUserCC
                ? rowData.IdUserCC.split(",").map((e) => parseInt(e))
                : [],
              IdRolCC: rowData.IdRolCC
                ? rowData.IdRolCC.split(",").map((e) => parseInt(e))
                : [],
              CCo: rowData.CCo ? rowData.CCo.split(",") : [],
              IdUserCCo: rowData.IdUserCCo
                ? rowData.IdUserCCo.split(",").map((e) => parseInt(e))
                : [],
              IdRolCCo: rowData.IdRolCCo
                ? rowData.IdRolCCo.split(",").map((e) => parseInt(e))
                : [],
            };
            setSelected(a);
            setShow(true);
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: listaCorreos,
    loading: loading,
    selected: selected,
    setSelected: (e) => setSelected(e),
  };

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div className="p-3">
      <Card
        titulo={
          <div className="d-flex gap-2">
            <h3>{getLabel(baseLang, "listaCorreos", config.language)}</h3>
            <CRUDListaCorreos
              show={show}
              setShow={setShow}
              listaEdit={selected}
              getInfoTable={getInfo}
            />
            <ConfirmDialog></ConfirmDialog>
            <Toast ref={toast}></Toast>
            <div className="botones">
              <Button icon="pi pi-refresh" onClick={getInfo} />
              <Button
                icon="pi pi-plus"
                severity="success"
                onClick={() => {
                  setSelected(null);
                  setShow(true);
                }}
              />
              <Button
                icon="pi pi-times"
                type="button"
                className="p-button-danger listado__botones"
                onClick={() => cerrarConfirmacion()}
                tooltip="Cancelar"
                tooltipOptions={{
                  className: "purple-tooltip",
                  position: "top",
                }}
                style={{ marginLeft: 1.5 }}
              ></Button>
            </div>
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
    </div>
  );
};

export default ListaCorreosScreen